module.exports = __webpack_public_path__ + "img/haywirethumb.fa05b481.jpg";